function attemptTurnstileToken() {
    return new Promise((resolve) => {
        if (!window.turnstile) {
            resolve(null);
            return;
        }

        const overlay = document.createElement('div');
        overlay.className =
            'fixed inset-0 z-[99999] flex items-center justify-center bg-black/40';

        const container = document.createElement('div');
        overlay.appendChild(container);
        document.body.appendChild(overlay);

        let settled = false;
        let widgetId;

        function cleanup() {
            try {
                if (widgetId !== undefined) {
                    window.turnstile.remove(widgetId);
                }
                overlay.remove();
            } catch (e) {
                // ignore cleanup errors
            }
        }

        try {
            widgetId = window.turnstile.render(container, {
                sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
                appearance: 'interaction-only',
                callback: (token) => {
                    if (!settled) {
                        settled = true;
                        cleanup();
                        resolve(token);
                    }
                },
                'error-callback': () => {
                    if (!settled) {
                        settled = true;
                        cleanup();
                        resolve(null);
                    }
                },
                'expired-callback': () => {
                    if (!settled) {
                        settled = true;
                        cleanup();
                        resolve(null);
                    }
                },
            });
        } catch (e) {
            cleanup();
            resolve(null);
            return;
        }

        setTimeout(() => {
            if (!settled) {
                settled = true;
                cleanup();
                resolve(null);
            }
        }, 60000);
    });
}

export async function getTurnstileToken() {
    if (!window.turnstile) {
        // Script hasn't loaded yet — wait and retry once
        await new Promise((r) => setTimeout(r, 500));
    }
    return attemptTurnstileToken();
}

export async function getMessagingTurnstileToken() {
    // Set VITE_TURNSTILE_MESSAGING_ENABLED=false to disable Turnstile for messaging only.
    if (import.meta.env.VITE_TURNSTILE_MESSAGING_ENABLED === 'false') {
        return 'disabled';
    }
    return getTurnstileToken();
}
